<div [class.col]="useColClass">
<!--    <label><span (click)="datepicker.toggle()">{{label}}&nbsp;<i class="fad fa-calendar"></i></span></label>-->
    <ng-template [ngIf]="useLabel"><label>{{label}}</label></ng-template>

    <div class="input-group">
        <div class="input-group-append">
            <a class="btn btn-outline-secondary" (click)="datepicker.toggle()" type="button"><i class="fad fa-calendar"></i></a>
        </div>
        <input name="datepicker" style="text-align: center;" readonly
               class="form-control"
               ngbDatepicker
               #datepicker="ngbDatepicker"
               [autoClose]="'outside'"
               (closed)="onClose()"
               (dateSelect)="onDateSelection($event)"
               [displayMonths]="2"
               [dayTemplate]="t"
               outsideDays="hidden"
               navigation="arrows"
               [startDate]="fromDate!"
               [value]="displayDateRange"
               tabindex="-1">
        <ng-template #t let-date let-focused="focused">
                <span class="custom-day"
                      [class.focused]="focused"
                      [class.range]="isRange(date)"
                      [class.faded]="isHovered(date) || isInside(date)"
                      (mouseenter)="hoveredDate = date"
                      (mouseleave)="hoveredDate = null">
                  {{ date.day }}
                </span>
        </ng-template>


    </div>

 <!--
    <div class="form-group hidden">
        <div class="input-group">
            <input name="datepicker2" readonly
                   class="form-control"
                   ngbDatepicker
                   #datepicker="ngbDatepicker"
                   [autoClose]="'outside'"
                   (dateSelect)="onDateSelection($event)"
                   [displayMonths]="2"
                   [dayTemplate]="t"
                   outsideDays="hidden"
                   [startDate]="fromDate!"
                   [value]="displayDateRange"
                   tabindex="-1">
            <ng-template #t let-date let-focused="focused">
                <span class="custom-day"
                      [class.focused]="focused"
                      [class.range]="isRange(date)"
                      [class.faded]="isHovered(date) || isInside(date)"
                      (mouseenter)="hoveredDate = date"
                      (mouseleave)="hoveredDate = null">
                  {{ date.day }}
                </span>
            </ng-template>

        </div>
    </div>

-->
</div>

<!--
<div class="col">
    <div class="form-group hidden">
        <div class="input-group">
            HELLO
            <input name="datepicker"
                   class="form-control"
                   ngbDatepicker
                   #datepicker="ngbDatepicker"
                   [autoClose]="'outside'"
                   (dateSelect)="onDateSelection($event)"
                   [displayMonths]="2"
                   [dayTemplate]="t"
                   outsideDays="hidden"
                   [startDate]="fromDate!"
                   tabindex="-1">
            <ng-template #t let-date let-focused="focused">
                <span class="custom-day"
                      [class.focused]="focused"
                      [class.range]="isRange(date)"
                      [class.faded]="isHovered(date) || isInside(date)"
                      (mouseenter)="hoveredDate = date"
                      (mouseleave)="hoveredDate = null">
                  {{ date.day }}
                </span>
            </ng-template>
        </div>
    </div>

    <div class="form-group">
        FROMDATE
        <div class="input-group">
            <input #dpFromDate
                   class="form-control" placeholder="yyyy-mm-dd"
                   name="dpFromDate"
                   [value]="formatter.format(fromDate)"
                   (input)="fromDate = validateInput(fromDate, dpFromDate.value)">
            <div class="input-group-append">
                <button class="btn btn-outline-secondary calendar" (click)="datepicker.toggle()" type="button"></button>
            </div>
        </div>
    </div>
    <div class="form-group ml-2">
        TODATE
        <div class="input-group">
            <input #dpToDate
                   class="form-control" placeholder="yyyy-mm-dd"
                   name="dpToDate"
                   [value]="formatter.format(toDate)"
                   (input)="toDate = validateInput(toDate, dpToDate.value)">
            <div class="input-group-append">
                <button class="btn btn-outline-secondary calendar" (click)="datepicker.toggle()" type="button"></button>
            </div>
        </div>
    </div>


</div>
-->

